import React, { Component } from 'react'

import Col2TextText from '../Sections/Col2TextText'
import Col2TextPicture from '../Sections/Col2TextPicture'
import Col1Text from '../Sections/Col1Text'
import ProductScreenshot from '../Sections/ProductScreenshot'
import ProductScreenshots from '../Sections/ProductScreenshots'
import PickANumber from '../Sections/PickANumber'
import Col3Text from '../Sections/Col3Text'
import PageLinks from '../Sections/PageLinks'
import PricingTable from '../Sections/PricingTable'
import MultiText from '../Sections/MultiText'
import TextBanner from '../Sections/TextBanner'
import Quiz from '../Sections/Quiz'
import NumberSearch from '../Sections/NumberSearch'
import Tabs from '../Sections/Tabs'
import HeadingDivider from '../Sections/HeadingDivider'
import ContactForm from '../Sections/ContactForm'
import TrustPilot from '../Sections/TrustPilot'
import Timeline from '../Sections/Timeline'
import CompareList from '../Sections/CompareList'
import BenefitsList from '../Sections/BenefitsList'
import ScreenshotsCarousel from '../Sections/ScreenshotsCarousel'
import Slider from '../Sections/Slider'
import BlogArticles from '../Sections/BlogArticles'

const getSectionFromId = (sectionId, props) => {
  const sectionMap = {
    section2ColumnTextText: <Col2TextText {...props} />,
    sectionColumn2TextPicture: <Col2TextPicture {...props} />,
    sectionColumn1Text: <Col1Text {...props} />,
    sectionPageLinks: <PageLinks {...props} />,
    sectionProductScreenshot: <ProductScreenshot {...props} />,
    sectionProductScreenshots: <ProductScreenshots {...props} />,
    sectionColumn3TextBullets: <Col3Text {...props} />,
    sectionPricingTable: <PricingTable {...props} />,
    sectionMultiText: <MultiText {...props} />,
    sectionTextBanner: <TextBanner {...props} />,
    sectionQuiz: <Quiz {...props} />,
    sectionNumberSearch: <NumberSearch {...props} />,
    sectionTabs: <Tabs {...props} />,
    sectionHeadingDivider: <HeadingDivider {...props} />,
    sectionPickANumber: <PickANumber {...props} />,
    sectionContactForm: <ContactForm {...props} />,
    sectionTrustPilot: <TrustPilot {...props} />,
    sectionTimeline: <Timeline {...props} />,
    sectionCompareList: <CompareList {...props} />,
    sectionBenefitsList: <BenefitsList {...props} />,
    sectionScreenshotsCarousel: <ScreenshotsCarousel {...props} />,
    sectionSlider: <Slider {...props} />,
    sectionBlogArticles: <BlogArticles {...props} />,
    error: <div>Error: {sectionId} not found</div>,
  }
  const section = sectionMap[sectionId]
  return section || sectionMap.error
}

export default class CmsSection extends Component {
  render() {
    const { section, location, appendToPageTitle } = this.props
    const sectionId = section.sys.contentType
    return getSectionFromId(sectionId, { ...section.fields, location, appendToPageTitle })
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/CmsSection/CmsSection.jsx